import { Chain } from 'wagmi'

export const botanixTestnet = {
  id: 3636,
  name: 'Botanix Testnet',
  network: 'botanix-testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Bitcoin',
    symbol: 'BTC',
  },
  rpcUrls: {
    default: { http: ['https://node.botanixlabs.dev'] },
    public: { http: ['https://node.botanixlabs.dev'] },
  },
  blockExplorers: {
    default: {
      name: 'Botanix Explorer',
      url: 'https://blockscout.botanixlabs.dev/',
    },
  },
} as const satisfies Chain